import { render, staticRenderFns } from "./Header1.vue?vue&type=template&id=83990886&"
import script from "./Header1.vue?vue&type=script&lang=ts&"
export * from "./Header1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports